export const COVERAGE_STATUSES = {
	toBeCovered: "TO_BE_COVERED",
	excluded: "EXCLUDED",
	toBeTested: "TO_BE_TESTED",
};
